import { render, staticRenderFns } from "./ListItemMultiline.vue?vue&type=template&id=b5160fb4&"
import script from "./ListItemMultiline.vue?vue&type=script&lang=js&"
export * from "./ListItemMultiline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem})
